// ⣿⡿⣟⣿⣻⣽⡯⣯⢯⢾⠽⢽⣹⢽⢽⢽⢽⣽⡽⣯⢿⡽⣯⡯⣿⢽⡯⣿⡽⣟⣿⣻⣟⣿⣟⣿⢿⣻⣿⣻⣿⣻⣿⣻⣿⣻⣿⣻⣿⣻⣟⣿⣻⣽⢿⡽⣯⢿⡽⣯⢿⡽⣯⣟⣯⡿⣯⣟⣯
// ⣿⡿⣿⡿⣟⣯⣿⣯⣟⣗⣯⡳⣕⢯⡱⡝⡽⣺⢯⣟⣯⢿⣳⡿⣽⢯⣟⣷⢿⣻⣽⣯⣿⣯⣿⣻⣿⢿⣽⣿⣽⡿⣾⣿⣽⢿⣾⣻⡾⣯⡿⣞⣿⣺⢯⢿⢽⣽⣺⣳⢯⣟⡷⡯⣷⣻⣗⣯⠷
// ⣿⡿⣿⣿⡿⣟⣗⣯⣻⢽⡾⣝⣯⣟⢮⣗⢽⡺⣽⣺⣺⣻⡽⣯⢿⣽⣻⡾⣟⣿⣽⡾⣷⢿⡾⣿⣽⢿⣻⣾⢷⣿⢿⣾⣟⣿⣳⡯⣟⡷⣟⣟⡷⣯⣻⢽⢽⣺⣞⣗⣟⡾⣽⣫⢷⡳⡫⡪⡝
// ⣿⡿⣿⣻⣟⣯⣿⣺⡮⣯⣻⢽⣞⡮⡧⡫⡣⣣⡳⣪⢺⢮⣻⢽⣻⣺⣗⡿⣯⢷⣯⢿⣻⣟⣿⣻⣾⢿⣯⡿⣿⣽⢿⡷⣿⡽⣯⢟⣗⡯⣟⢾⢽⣺⣺⢽⢽⣳⣻⣞⡷⡯⡳⡹⡜⢎⠪⡪⠬
// ⣿⣻⣿⡿⣿⣻⣾⢯⣿⢵⣻⣽⢾⡯⣯⢫⢪⠢⡙⣜⢵⡹⣞⢯⣗⣟⡮⡯⣯⢿⣺⣟⣷⣻⣾⣻⡾⣟⣷⡿⣯⣿⣻⡿⣽⣯⡯⣟⡮⣟⢾⢽⢽⣺⢽⢽⣫⢷⣻⢮⢯⣳⠩⡨⢢⢡⢣⡪⣫
// ⣽⣿⣽⡿⣿⣻⣟⣿⣽⡿⣯⣯⢟⣮⣳⣝⢮⡪⡐⡅⢕⠪⡎⡗⣳⡳⡯⡯⡺⡯⣗⣟⡾⣳⢯⡷⣿⣻⢷⣻⣟⡾⣯⢿⣽⣞⣯⣯⢿⡽⣯⢿⢽⣺⢯⣟⢾⢽⣺⢽⣽⣺⢈⠢⡣⡣⣣⡫⣞
// ⡿⣾⢯⣿⣿⣻⣟⣯⣿⣻⢿⣞⣯⢷⣳⡳⡝⡮⡊⡢⢂⠡⢑⢑⠘⢌⢝⢮⢏⢯⣳⢳⢝⢽⢕⡯⣗⡯⣟⡷⣯⢿⢽⡻⠾⡽⠾⢽⢯⢯⡯⡿⡽⡾⣽⣺⢽⢽⣺⢽⣺⣺⢐⢱⢱⢱⢕⣝⢮
// ⡿⣯⢿⣻⣾⣻⣯⢿⡽⡽⡽⡾⣯⢯⣗⢯⡳⡕⡕⢌⢂⠪⢐⠐⠅⠅⡊⠸⢱⠱⡱⡹⡪⡓⡝⡽⣱⢽⡱⡽⣺⣺⣳⢽⢯⡯⣯⢷⡽⡵⣝⣝⢝⠯⣗⡯⣟⣽⣺⢽⣺⢞⠔⡅⡇⡗⣝⢮⡳
// ⡿⣯⣟⣟⢾⢽⣺⢽⢽⢯⣟⡯⣯⡻⡮⡳⣕⢳⠨⢂⢐⢅⢊⠌⠌⡐⠌⠌⡂⡅⡇⡕⡪⡸⣸⡺⡳⡵⣫⢾⣝⢾⢽⣻⡽⡯⣯⠳⡹⣝⢞⡮⡯⣻⢬⢝⢵⣳⢽⢽⣺⢽⠡⡪⡪⣚⢮⣳⡫
// ⣟⣗⡧⣗⡿⣽⡺⡽⡹⢝⢮⢯⢳⢫⠫⡪⢪⠪⡘⢄⢕⢰⠡⡊⠔⢨⢨⡢⢇⣷⣇⢧⢃⢧⢳⡱⣝⢽⢝⣗⠽⡳⣳⢕⡝⣝⢎⢇⠅⠣⡫⡺⡪⣳⡹⣝⢮⡺⡽⣽⡺⣝⢕⠸⡸⣜⣕⢧⣫
// ⣾⣳⣻⣳⡻⡮⡯⣳⢱⠱⡑⢕⠱⡱⡑⠅⠅⢃⢊⠢⠡⡃⡑⡠⡱⢑⣕⡮⡷⣵⡣⢏⡳⡩⡳⡣⣗⡝⣗⢗⡽⣪⢊⢓⠝⡜⡘⠌⠌⡊⡐⠌⠪⡪⢎⢷⢝⡽⣝⢞⡮⣗⢕⢱⢱⡣⡷⡉⣄
// ⢷⣳⣳⣳⡻⣮⡫⣎⢎⢧⡣⡕⡡⠢⡈⡊⠨⢐⠨⡈⢆⢢⢢⢣⢮⣿⣺⡽⣯⣗⠕⡱⢸⡨⢎⢞⠮⣺⡪⡳⡝⡮⡢⡱⠀⠅⠂⠌⡐⡀⡂⢌⢐⠨⢈⢊⢳⢝⢮⢯⡺⣵⠱⡸⡸⡸⣝⢐⢵
// ⣟⡾⣵⡳⣯⣳⢽⣪⢞⡵⣫⡺⡸⡐⠔⢌⠌⡢⢂⢎⢎⢦⣳⣽⣻⣾⣯⢿⡳⡕⡡⡎⡃⡊⡎⡖⡍⡖⡝⡜⡜⠌⡪⠐⢁⠅⡕⢕⢱⢸⢨⡢⣣⢪⡢⡢⡌⠪⡣⡳⡝⡮⡣⡱⡱⡕⣗⠅⡗
// ⣳⢯⣳⣻⣺⡺⣝⡮⡷⣝⢮⢎⢇⢎⠌⡢⠨⡈⣎⡮⣯⣯⣷⣿⣽⡾⣯⡻⣘⡴⡹⡰⡪⢸⢸⢪⢪⠐⠅⢕⢌⢂⠐⠈⢄⢃⠇⢧⢳⢝⣞⣮⢷⣻⣽⢽⣪⣇⢪⢊⢎⢞⡌⡆⡧⣫⣺⢐⢝
// ⣯⣻⣺⣺⢮⢯⣗⢯⢯⡺⣪⢺⢐⠡⣑⡰⣵⣜⣾⣽⣟⣷⣿⢾⣯⣟⡗⠯⡣⡱⡱⣱⢱⢝⢜⢎⢇⠇⠅⠂⢂⠐⢈⠨⡐⢕⢌⢪⣊⣆⣖⣜⣯⣷⣻⣯⣷⣯⡷⣵⣵⣽⣼⣜⣮⣞⢮⡢⣓
// ⣳⣳⣗⡯⣯⣗⡯⣯⡳⣝⢮⠪⣄⢵⣳⣟⣷⣟⣾⢷⣿⣻⡾⡻⠾⢴⢫⢫⡪⡝⡜⡎⡎⣎⢇⢇⢇⢍⢊⠈⠄⡐⡐⡌⡎⢜⢩⣣⣳⣳⣵⡯⡗⣮⢺⣽⣾⣷⣻⢰⢙⢼⡸⡸⠽⣹⣫⣿⣿
// ⣺⡵⣗⣯⢷⣳⣻⢮⡻⡮⡳⣱⢽⣯⣿⣽⡿⣾⡯⣟⢷⡹⡮⡣⡫⢮⢺⢪⡪⡎⡗⣝⢜⢎⡎⡇⣇⠢⢂⠨⠐⠐⢌⢪⢞⢼⡲⡸⣾⣺⢷⣟⡯⣾⣹⣽⣷⢿⢧⢑⡱⡹⡬⡮⣫⢺⢜⣞⡿
// ⣯⢿⡽⣞⣯⣟⣞⣯⢯⢯⣣⣻⣯⣷⣿⣷⢿⣯⢯⡓⠩⡛⢮⣧⣣⡣⣣⢣⡣⡏⣞⢎⡗⡵⡹⣜⢜⡜⡔⡌⢌⢂⠅⡣⡇⣗⣯⢺⣮⣻⢿⣽⢵⣿⡮⣿⣻⣟⢵⣱⡇⡿⣜⢮⢺⡸⣟⣞⣝
// ⣯⡯⣿⢽⣞⣞⣗⡯⣟⣽⡪⣟⣾⢿⣾⣟⣿⣝⢗⢝⢗⠬⡢⠪⣪⡫⣝⣕⢧⢫⡪⡣⡯⣺⢹⢜⢵⢕⢇⡇⣆⠣⡊⢔⠡⡣⡳⣽⣷⣗⢿⢧⣿⣾⣯⢯⢏⢆⢧⢳⡘⡜⡜⡜⣜⢮⡚⡖⣕
// ⣾⢽⣽⣻⣺⣳⢯⡯⣗⡷⣝⢞⣽⡿⣯⣿⢷⣟⠯⡳⡲⢅⠢⡣⣣⡳⣕⢮⡳⡳⣕⢝⣞⢼⢕⣏⢧⣫⡺⡜⣆⠣⣊⠢⡱⡱⢱⢕⢻⢺⢫⢞⢟⢞⡕⡇⣇⢗⢵⠱⡱⣑⢱⢸⢜⡲⡱⡝⣎
// ⡺⣽⣺⣺⣳⢯⣟⣞⢷⢽⡺⣕⢿⣟⣿⣽⡿⣾⢽⡬⣔⡈⢇⢗⢵⢝⡮⣳⢽⢝⣎⢗⡵⣝⣕⢧⡳⣕⢗⢽⡸⣱⢘⢌⢢⢑⢕⠕⡕⡕⣝⡝⡮⡣⡳⣩⢺⢜⢅⢳⢨⢢⡣⡳⡱⣕⢝⢼⢸
// ⣞⢵⣳⣳⡫⣗⢷⢽⢽⢕⡯⣺⢕⡗⣿⡾⣿⣻⣽⣪⢔⢨⠰⡸⡕⡯⣺⢕⡯⡳⣕⢯⢺⢜⢼⢕⣝⢮⣫⢳⢝⢮⡂⠇⡊⢆⡣⡳⡱⡹⡲⡱⡕⣍⢞⡜⣕⢭⡣⡳⣑⠵⣕⢝⢮⡪⣳⢹⡪
// ⢳⢝⢮⡺⣪⢯⡫⣞⢵⡫⣞⣕⢗⡝⡮⡻⢽⣻⡾⣯⣗⢔⢱⢱⡹⣪⢳⢝⢎⡏⡮⡺⡸⡱⡹⡱⣕⢗⢵⢝⡝⡮⡪⡨⢨⢰⢱⢡⢫⢪⡺⢜⢕⠵⣍⠮⡺⣌⢞⠜⡜⡭⡪⣎⢧⢫⡪⣣⢳
// ⡵⡹⣕⢝⢮⢳⢝⢮⡳⡝⣎⢮⡣⣏⢮⢪⢳⢹⢻⣻⣾⣻⣪⣪⡪⣪⢣⡫⡪⡪⡪⢪⢸⢸⢸⠱⡕⡝⡜⡮⣪⢳⢕⠌⠆⣇⢇⢇⠧⡣⣃⢝⢕⡵⡕⡝⡮⣚⢮⢽⡸⡪⡣⡇⡗⡵⡹⡜⣎
// ⢪⢪⡪⡣⡫⡎⡗⡵⡱⡣⡳⡱⡣⡳⡱⡝⡜⡜⡔⡕⣟⣾⣳⣗⡷⣕⡕⡅⡃⡕⡜⡌⢆⢣⠪⡪⢪⢪⢪⢎⢧⢳⢑⠱⡱⣑⢕⢕⢭⢪⢪⢺⢸⢱⢪⠻⡜⡝⣗⢕⢝⢜⢎⣇⣧⢷⣻⣾
// ⢸⢘⢜⢜⢜⢜⢜⢜⠜⡜⢜⢜⢜⢕⢕⢝⢜⢜⠬⣳⢽⢮⢳⢻⠎⢎⠪⢀⢇⢎⠜⢌⠢⡃⢎⠜⡰⡑⡕⡕⣇⢯⢢⡫⡮⡲⡱⡱⡱⡸⡸⡸⡸⡰⡱⡱⣙⣜⡼⡼⣵⢯⢷⣻⣻⢽⢽
// ⠐⢅⢊⠆⢕⠡⡱⢘⠌⡌⡢⠪⡘⡌⢎⠜⢔⠱⡑⡕⡇⡏⢷⡱⡑⠅⢕⠔⡕⢅⠕⢅⠣⡑⢌⠢⡑⢔⠱⡸⡸⡸⡪⣣⢳⢱⢹⠸⡸⢨⠢⡱⠨⡢⢊⢆⣎⢮⢾⡾⡽⢝⡽⣏⢾⣺⣺⡽⣻
// ⢈⢂⠢⡁⠢⡈⡢⢑⠨⡐⠄⢕⠰⠨⡢⡑⡡⢑⢱⠨⡪⡘⢌⠪⢐⠡⡑⡑⢌⠢⢡⠡⡑⢌⠢⠡⢊⢐⠅⡪⢪⠪⡪⡪⢪⠪⡘⡌⣊⠢⡑⢌⢪⡲⡹⡕⣗⢯⢯⢩⢜⡼⡺⣕⣟⣞⣗⡿⡽
// ⢔⢡⠪⠠⢑⢐⢌⠢⠡⡂⢅⠕⢬⡺⣝⡰⡨⣌⡆⡣⣱⡨⡔⣌⢆⡇⡕⣌⡢⣱⣐⣅⢪⡪⡮⡪⣢⢑⢌⡬⡢⡕⣅⢇⡕⡬⡢⣕⢔⣕⢨⣪⣳⢝⠼⠼⣞⢝⢵⡹⣕⣽⣹⣺⣺⣺⡪⡯⡫
// ⣣⢇⢇⢣⠡⣒⢜⢼⢕⡵⡱⣌⡳⣘⢲⡃⠀⠀⣇⡗⠁⠀⣰⠣⣳⠀⠀⠀⠀⠀⠀⠈⠱⣳⡀⠀⠀⢧⣳⠁⠀⢰⡇⠀⠀⠀⠀⠀⠀⣸⢵⠃⠀⠀⠀⠀⠀⠙⢷⣟⣿⣞⡿⣞⣷⢷⡿⣽⢕
// ⡯⡯⡷⣵⢵⡱⣕⢷⢽⢽⢯⣗⡷⡵⣸⡅⠀⠀⠗⠁⠀⡼⡱⡱⣹⠀⠀⠀⣏⢷⠀⠀⠀⡯⣳⡀⠀⠈⠇⠀⢀⣏⢏⡻⡆⠀⠀⢼⢚⢮⠃⠀⠀⣸⣻⡧⠀⠀⠈⣷⣿⣾⣿⣿⣯⣿⣽⢽⠢
// ⣯⣟⣯⢿⣽⣯⣟⣷⢿⣽⣳⡯⡾⣝⣗⡇⠀⠀⠀⠀⠀⠘⡎⢌⢺⠀⠀⠀⠀⠀⠀⢀⡴⡫⡪⣳⡀⠀⠀⠀⣞⢎⢕⢎⡇⠀⠀⢜⢐⢽⠀⠀⠀⣞⣷⡿⠀⠀⠀⣿⣿⣿⣟⣷⡿⣗⡟⡜⡌
// ⣿⣞⣯⡿⣷⣻⣾⣻⣯⢿⣳⣟⡯⣗⣟⡆⠀⠀⣰⡆⠀⠀⠹⡰⣸⠀⠀⠀⣟⢞⢏⢏⡪⡸⡬⠖⠗⠀⠀⣸⡱⡱⡱⡱⡇⠀⠀⢺⢵⢽⡅⠀⠀⠸⢮⠏⠀⠀⢰⢿⣟⣿⣟⣿⣻⣝⢎⢎⢎
// ⡷⣻⠽⡯⡻⡝⡺⡳⢽⢹⢕⢗⣝⡕⣜⡅⠀⠀⡧⣹⡆⠀⠀⠹⣺⠀⠀⡀⡷⣝⢮⣳⡱⣕⡇⠀⢀⢀⡴⡣⡱⡱⡱⣕⡇⠀⠀⣹⡳⣝⣟⣦⡀⠀⠀⠀⣀⡴⡯⣗⣗⣗⡷⣽⣺⢪⡪⡪⡪
// ⣏⡮⣳⡹⣚⣎⢯⣫⢯⡳⡫⡛⡮⡣⡣⡫⡫⣟⣗⣗⣿⣟⣿⣻⢯⣻⣫⣟⢽⡳⣝⢜⢎⢮⡻⡯⡿⣽⢮⣞⣮⣳⣝⣮⡻⣝⡯⣳⣝⡮⣞⣾⣻⣻⣿⣻⣯⡿⣯⡿⣞⣯⣯⢷⡳⣣⡣⣣⢧
// ##############----------+++####################----+###########   
// ##############----------+++###################----++###########   
// ##############----------++###################---+++############   
// ##############+--------+++#################+---++##############   
// ###############--------++################+---+++###############   
// ###############--------++##############+----+++################   
// ###############--------++############+----+++-------###########   
// ###############-------+-+##########+----++++----++-++-+########   
// ###############---------++++++++++----+++#+----+##++++++#######   
// ###############---------------------++++###++++###+++++-#######   
// ###############-------------------++++############++++++#######   
// ##############+------------------++++##########+#+++++++#######   
// ##########+#+--------------------++++############++##+++#######   
// ########+++-----------------------+++####+####+#######++#######   
// ########++-------------------------++####++++##########+#######   
// ########----------------------------+++++#+##++++++--++########   
// ########-----------------------------+-++###++++++++++++###+###   
// ########+-------------+++++++++++++--+#+###+----+--+++#++######   
// #########+---------++++####+######++++###+++----+-----+##+#####   
// ##########+-------+++################+####+++--++------+#+#####   
// ########+#+------+++#####+########++##+##++++----------+#+####+   
// #######+-+------+++####+##########++#######+++------++++#######   
// #######---------++++###++++#######+++#####++++-+--+++++########   
// ######+-----------++####++++#####++++######++--+#++#+##########   
// ######--------------++#########+++#######+----+##++############   
// #####+----------------+++++++++++#####+-----+##################   
// ####++++++++++++++------+++++++#####-----++####################   
// ####++++++++++#++++++++++++++#####------+######################   
// ####++#######+----++############+-----------+++################   
// #####++##+++-----+++###########+-----------------+#############   
// ######++##+++-+++++###########-------------+++++++#############   
// ############++##############+#+--------+++#####################   
// ############+++##############+++---++++########################   
// #############################+##++++###########################   
// ##############################+################################   
// ###############################################################   
// ###############################################################   
// ###############################################################   
// ###############################################################   
// ###############################################################   
// #####################################################++########   

import React, { useState, useEffect, useCallback, useRef } from "react";

import faviconUrl from "./assets/favicon.png";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import translations from "./translations";
import { API_URL } from "./config";
import {
  setBodyBg,
  useBodyBgTransition,
  globalThemeTransitionStyles,
} from "./styles/commonHooks";
import axios from "axios";
import { createToast } from "./hooks/useToast";

import { logError, logNavigation, logPageLoad } from "./utils/logger";

// Layout
import SiteHeader from "./components/SiteHeader";
import MobileSiteHeader from "./components/MobileSiteHeader";
import Footer from "./components/Footer";
import ToastNotifications from "./components/ToastNotifications";

// Pages ────────────────────────────────────────
import LandingPage from "./pages/Landing/LandingPage";
import HowItWorks from "./pages/Landing/HowItWorks";
import PrivacyPolicy from "./pages/Landing/PrivacyPolicy";

import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";

import ChatPage from "./pages/ChatPage";
import CVGeneratorPage from "./pages/CVGeneratorPage";

import EventsPage from "./pages/events/EventsPage";
import EventCreatePage from "./pages/events/CreateEvents";
import EventEditRequestPage from "./pages/events/EditEventRequest";
import EventDetailPage from "./pages/events/EventDetailPage";
import EventAdminDashboard from "./pages/events/EventAdminDashboard";

import InvitePage from "./pages/ProfilePage";
import InviteErrorPage from "./components/InviteErrorPage";

import ModeratorPanel from "./pages/a/ModeratorPanel";
import ModeratorLoginPage from "./pages/a/ModeratorLoginPage";

import SystemStatusPage from "./pages/SystemStatusPage";

// Глобальный обработчик ошибок
window.onerror = (message, source, lineno, colno, error) => {
  logError(`Global error: ${message}`, error, { source, lineno, colno });
  return false;
};

window.onunhandledrejection = (event) => {
  logError(`Unhandled promise rejection: ${event.reason}`, event.reason);
};

const RouteLogger = () => {
  const location = useLocation();
  const prevLocationRef = React.useRef(location.pathname);
  
  useEffect(() => {
    const startTime = performance.now();
    if (prevLocationRef.current !== location.pathname) {
      logNavigation(prevLocationRef.current, location.pathname);
      prevLocationRef.current = location.pathname;
    }

    const loadTime = Math.round(performance.now() - startTime);
    logPageLoad(location.pathname, loadTime);
  }, [location]);
  
  return null;
};

const darkTheme = {
  bg: "#1a1a2e",
  fg: "#ffffff",
  card: "#16213e",
  btnBg: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  btnFg: "#ffffff",
  input: "#0f3460",
  border: "#667eea",
  subtleBg: "rgba(30, 40, 80, 0.18)",
  cardHover: "rgba(70, 90, 160, 0.14)",
  smallText: "#cbd5e1",
};

const lightTheme = {
  bg: "linear-gradient(135deg, #f6f8ff 0%, #eef3ff 36%, #f7f2ff 68%, #eef9ff 100%)",
  fg: "#182033",
  card: "rgba(255,255,255,0.76)",
  btnBg: "linear-gradient(135deg, #5b6ee1 0%, #7c4dff 100%)",
  btnFg: "#ffffff",
  input: "#eef3ff",
  border: "#7b83e6",
  subtleBg: "rgba(228, 234, 255, 0.68)",
  cardHover: "rgba(91, 110, 225, 0.12)",
  smallText: "#4f5f7e",
};

const fastThemeTransitionStyles = `
  @media (prefers-reduced-motion: no-preference) {
    html,
    body,
    #root {
      transition:
        background 0.24s cubic-bezier(0.22, 1, 0.36, 1),
        color 0.18s ease;
    }
  }
`;

const getInitialToken = () => {
  const storedToken = localStorage.getItem("token");
  const loginTime = localStorage.getItem("loginTimestamp");
  const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;
  
  if (storedToken && loginTime) {
    const isExpired = Date.now() - parseInt(loginTime, 10) > SEVEN_DAYS_MS;
    if (isExpired) {
      localStorage.removeItem("token");
      localStorage.removeItem("loginTimestamp");
      return "";
    }
    return storedToken;
  }
  return "";
};

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const loginTime = localStorage.getItem("loginTimestamp");
  const location = useLocation();
  
  const isPublicPage = 
    location.pathname === "/" ||                                      // Главная страница
    location.pathname === "/how-it-works" ||                          // Как это работает
    location.pathname === "/privacy-policy" ||                        // Политика конфиденциальности
    /^\/events\/\d+$/.test(location.pathname) ||                      // Числовой идентификатор ивента
    /^\/events\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(location.pathname) || // UUID ивента
    location.pathname === "/auth" ||                                  // Страница авторизации
    location.pathname === "/register";                                // Страница регистрации
  
  // 🔥 Если это публичная страница - показываем контент без авторизации
  if (isPublicPage) {
    return children;
  }
  
  // Для всех остальных роутов проверяем авторизацию
  const isExpired = loginTime && Date.now() - parseInt(loginTime) > 7 * 24 * 60 * 60 * 1000;
  
  if (!token || isExpired) {
    if (isExpired) {
      localStorage.removeItem("token");
      localStorage.removeItem("loginTimestamp");
    }
    // Редирект на страницу авторизации
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }
  
  return children;
};

// Защита маршрута панели модератора.
// Если studio_token отсутствует — перенаправляет на страницу логина.
const ProtectedModRoute = ({ children, adminRoute }) => {
  const token = sessionStorage.getItem("studio_token");
  if (!token) {
    return <Navigate to={`/${adminRoute}/login`} replace />;
  }
  return children;
};

const AppContent = () => {
  const location = useLocation();
  const isSamsungBrowser = false;
  const isGuruDomain =
    typeof window !== "undefined" &&
    ["connectguru.ai", "www.connectguru.ai"].includes(window.location.hostname);
  // Язык по умолчанию — французский. Если у пользователя уже сохранён выбор
  // в localStorage — уважаем его (в т.ч. "en" после ручного переключения).
  // Прежняя ветка `if (isGuruDomain) return "en"` снята: по политике продукта
  // первым языком должен быть FR независимо от домена.
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "fr");
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");
  const [token, setToken] = useState(getInitialToken());
  const [viewportWidth, setViewportWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );
  
  // Добавляем состояние для матчей
  const [pendingMatchesCount, setPendingMatchesCount] = useState(0);
  const [, setMatchesLoading] = useState(false);

  // ── Динамический маршрут панели администратора ──────────────────────────
  // Маршрут хранится только в памяти (не в localStorage/sessionStorage).
  // Загружается только для пользователей из белого списка ADMIN_USER_IDS.
  // adminRoute хранится в sessionStorage — переживает F5 без потери маршрута.
  // При монтировании читаем сразу, API-запрос идёт в фоне для обновления.
  const [adminRoute, setAdminRoute] = useState(
    () => sessionStorage.getItem("studio_admin_route") || null
  );
  const adminRouteTimerRef = React.useRef(null);

  // Ref для открытия AuthModal внутри EventDetailPage с хедера
  // EventDetailPage регистрирует свою функцию открытия через onRegisterAuthModal
  const eventAuthModalRef = useRef(null);
  const mainScrollRef = useRef(null);

  const fetchAdminRoute = useCallback(async (currentToken) => {
    if (!currentToken) return;
    try {
      const { data } = await axios.get(`${API_URL}/api/mod/current-route`, {
        headers: { Authorization: `Bearer ${currentToken}` },
      });
      sessionStorage.setItem("studio_admin_route", data.route);
      setAdminRoute(data.route);
      if (adminRouteTimerRef.current) clearTimeout(adminRouteTimerRef.current);
      const refreshIn = ((data.rotates_in_secs || 3600) + 5) * 1000;
      adminRouteTimerRef.current = setTimeout(() => fetchAdminRoute(currentToken), refreshIn);
    } catch {
      // Пользователь не является администратором — маршрут не нужен
      sessionStorage.removeItem("studio_admin_route");
      setAdminRoute(null);
    }
  }, []);

  useEffect(() => {
    fetchAdminRoute(token);
    return () => {
      if (adminRouteTimerRef.current) clearTimeout(adminRouteTimerRef.current);
    };
  }, [token, fetchAdminRoute]);

  const themeVars = (isSamsungBrowser ? 'light' : theme) === "dark" ? darkTheme : lightTheme;
  const effectiveTheme = isSamsungBrowser ? 'light' : theme;
  const isMobile = viewportWidth <= 750;
  const isProfilePage = location.pathname === "/profile";
  const isEffectiveLight = effectiveTheme !== "dark";
  const profilePageBackground = isEffectiveLight
    ? "radial-gradient(ellipse 46% 38% at 14% 0%, rgba(91, 110, 225, 0.20), transparent 68%), radial-gradient(ellipse 50% 42% at 90% 4%, rgba(45, 212, 191, 0.16), transparent 66%), radial-gradient(ellipse 42% 36% at 76% 96%, rgba(168, 85, 247, 0.12), transparent 68%), linear-gradient(180deg, #fbfcff 0%, #eef3ff 54%, #f8f3ff 100%)"
    : "radial-gradient(ellipse 50% 45% at 15% 0%, rgba(139, 92, 246, 0.45), transparent 65%), radial-gradient(ellipse 55% 50% at 90% 5%, rgba(34, 211, 238, 0.32), transparent 65%), radial-gradient(ellipse 45% 40% at 75% 95%, rgba(168, 85, 247, 0.28), transparent 65%), radial-gradient(ellipse 40% 35% at 10% 85%, rgba(56, 189, 248, 0.22), transparent 65%), #060d1f";
  const activePageBackground = isProfilePage ? profilePageBackground : themeVars.bg;
  const headerInsetPx = isMobile ? 0 : 4;
  const desktopMainPaddingTop = "70px";
  /** Mobile fixed header is 76px; profile pages already add their own inner top gap. */
  const mobileMainPaddingTop = isProfilePage ? "76px" : "84px";

  // Определяем страницы без хедера
  const isNewsPage = (
    location.pathname === "/system-status" ||
    (adminRoute && location.pathname === `/${adminRoute}`) ||
    (adminRoute && location.pathname === `/${adminRoute}/login`) ||
    (adminRoute && location.pathname.startsWith(`/${adminRoute}/`) && location.pathname !== `/${adminRoute}/login`)
  );

  // Страница EventAdminDashboard — хедер есть, но она управляет своим отступом сама
  const isEventAdminPage = /^\/events\/[^/]+\/admin$/.test(location.pathname);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (location.pathname === "/profile" && params.has("section")) return;

    mainScrollRef.current?.scrollTo({ top: 0, left: 0, behavior: "auto" });
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.search, location.key]);
  
  useEffect(() => {
    const link =
      document.querySelector("link[rel='icon']") ||
      document.createElement("link");
    link.rel = "icon";
    link.href = faviconUrl;
    document.head.appendChild(link);
  }, []);
  
  useEffect(() => {
    if (token) {
      localStorage.setItem("token", token);
    } else {
      localStorage.removeItem("token");
      localStorage.removeItem("loginTimestamp");
    }
  }, [token]);
  
  useEffect(() => {
    localStorage.setItem("lang", lang);
  }, [lang]);
  
  useBodyBgTransition();

  useEffect(() => {
    localStorage.setItem("theme", theme);
    setBodyBg(activePageBackground);
    document.body.style.color = themeVars.fg;
    document.body.style.margin = "0";
  }, [theme, themeVars, activePageBackground]);
  
  useEffect(() => {
    const handleResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ── Глобально блокируем touch-зум на всём сайте ────────────────────────
  // Убирает pinch-to-zoom и нативный double-tap-to-zoom во всех браузерах.
  // Кастомный double-tap в ChatPage'е продолжит работать — он слушает touchend
  // на своём собственном элементе, а мы блокируем только дефолты браузера.
  useEffect(() => {
    // 1) viewport meta — запрещаем пользовательское масштабирование
    //    (работает в Android/Chromium, игнорируется iOS 10+)
    let meta = document.querySelector("meta[name='viewport']");
    const originalMetaContent = meta ? meta.getAttribute("content") : null;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "viewport");
      document.head.appendChild(meta);
    }
    meta.setAttribute(
      "content",
      "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, viewport-fit=cover"
    );

    // 2) touch-action: manipulation на html+body — убирает нативный
    //    double-tap-to-zoom на iOS 13+ и современном Android
    const prevHtmlTouchAction = document.documentElement.style.touchAction;
    const prevBodyTouchAction = document.body.style.touchAction;
    document.documentElement.style.touchAction = "manipulation";
    document.body.style.touchAction = "manipulation";

    // 3) iOS игнорирует user-scalable=no — блокируем его pinch через
    //    специфичные события gesturestart/change/end
    const preventGesture = (e) => {
      e.preventDefault();
    };
    document.addEventListener("gesturestart", preventGesture, { passive: false });
    document.addEventListener("gesturechange", preventGesture, { passive: false });
    document.addEventListener("gestureend", preventGesture, { passive: false });

    // 4) Android/Chromium — блокируем pinch через touchmove с 2+ пальцами.
    //    Одно касание (обычный скролл) не трогаем.
    const preventPinch = (e) => {
      if (e.touches && e.touches.length > 1) {
        e.preventDefault();
      }
    };
    document.addEventListener("touchmove", preventPinch, { passive: false });

    return () => {
      if (originalMetaContent !== null) {
        meta.setAttribute("content", originalMetaContent);
      } else {
        meta.remove();
      }
      document.documentElement.style.touchAction = prevHtmlTouchAction;
      document.body.style.touchAction = prevBodyTouchAction;
      document.removeEventListener("gesturestart", preventGesture);
      document.removeEventListener("gesturechange", preventGesture);
      document.removeEventListener("gestureend", preventGesture);
      document.removeEventListener("touchmove", preventPinch);
    };
  }, []);
  
  const clearSession = () => {
    setToken("");
    localStorage.removeItem("token");
    localStorage.removeItem("loginTimestamp");
    localStorage.removeItem("userQRCode");
    localStorage.removeItem("inviteCode");
  };
  
  const handleLogin = (newToken) => {
    localStorage.setItem("token", newToken);
    localStorage.setItem("loginTimestamp", Date.now().toString());
    setToken(newToken);
    document.cookie = `sessionid=fake-session-${Date.now()}; path=/; max-age=31536000; Secure; SameSite=Lax`;
  };
  
  const handleLogout = () => {
    clearSession();
  };
  
  const handleToggleTheme = () =>
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  
  const handleToggleLang = (nextLang) => {
    if (nextLang) {
      setLang(nextLang);
      return;
    }
    setLang((prev) => (prev === "en" ? "fr" : "en"));
  };
  
  // Показываем футер на всех страницах КРОМЕ /chat и панели модератора
  const showFooter = !(
    location.pathname.startsWith("/chat") ||
    location.pathname.startsWith("/system-status") ||
    location.pathname.startsWith("/register") || 
    location.pathname.startsWith("/auth") ||
    location.pathname === "/events/create" ||
    (adminRoute && location.pathname === `/${adminRoute}`) ||
    (adminRoute && location.pathname === `/${adminRoute}/login`) ||
    (adminRoute && location.pathname.startsWith(`/${adminRoute}/`) && location.pathname !== `/${adminRoute}/login`) ||
    /^\/events\/[^/]+\/edit$/.test(location.pathname) ||
    isEventAdminPage
  );
  
  // ── Хелперы для сохранения известных ID матчей в localStorage ──────────
  // Ключ включает первые 20 символов токена — разные юзеры не перезаписывают друг друга
  const matchStorageKey = token ? `known_match_ids_${token.slice(0, 20)}` : null;

  const getSavedMatchIds = useCallback(() => {
    if (!matchStorageKey) return null;
    try {
      const saved = localStorage.getItem(matchStorageKey);
      return saved ? new Set(JSON.parse(saved)) : null;
    } catch {
      return null;
    }
  }, [matchStorageKey]);

  const saveMatchIds = useCallback((ids) => {
    if (!matchStorageKey) return;
    try {
      localStorage.setItem(matchStorageKey, JSON.stringify([...ids]));
    } catch {
      // localStorage может быть недоступен (приватный режим и т.д.)
    }
  }, [matchStorageKey]);

  const loadPendingMatchesCount = useCallback(async () => {
    if (!token) return;
    
    try {
      setMatchesLoading(true);
      const { data } = await axios.get(`${API_URL}/api/matches/by_category`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (data.success) {
        const matchesByCategory = data.matches_by_category || {};
        const allMatches = Object.values(matchesByCategory).flat();
        const pendingMatches = allMatches.filter(m => m.my_status === "pending");
        setPendingMatchesCount(pendingMatches.length);

        const currentIds = new Set(pendingMatches.map(m => m.id));
        const savedIds = getSavedMatchIds();

        if (savedIds === null) {
          // Первый визит вообще (localStorage пуст) — запоминаем, тост не показываем
          saveMatchIds(currentIds);
        } else {
          // Сравниваем с тем что было сохранено (работает даже после закрытия сайта)
          const newMatches = pendingMatches.filter(m => !savedIds.has(m.id));
          if (newMatches.length > 0) {
            const count = newMatches.length;
            const msg = lang === "fr"
              ? count > 1
                ? `Vous avez ${count} nouveaux matchs ! Consultez votre profil`
                : `Vous avez un nouveau match ! Consultez votre profil`
              : count > 1
                ? `You have ${count} new matches! Check your profile`
                : `You have a new match! Check your profile`;
            createToast(msg, "bottom", 10000);
          }
          // Всегда обновляем сохранённые ID
          saveMatchIds(currentIds);
        }
      }
    } catch (err) {
      console.error("Error loading pending matches count:", err);
      setPendingMatchesCount(0);
    } finally {
      setMatchesLoading(false);
    }
  }, [token, lang, getSavedMatchIds, saveMatchIds]);

  // Запускаем при изменении токена (логин / логаут)
  useEffect(() => {
    loadPendingMatchesCount();
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  // Автообновление каждые 12 секунд
  useEffect(() => {
    const interval = setInterval(() => {
      loadPendingMatchesCount();
    }, 12000);
    
    return () => clearInterval(interval);
  }, [loadPendingMatchesCount]);

  // ────────────────────────────────────────────────
  // Глобальные стили скроллбара
  // ────────────────────────────────────────────────
  const globalScrollStyles = `
    /* Firefox */
    * {
      scrollbar-width: thin;
      scrollbar-color: ${theme === "dark" ? "#6366f1" : "#6366f1"} ${theme === "dark" ? "rgba(30, 41, 59, 0.5)" : "rgba(241, 245, 249, 0.8)"};
    }
    
    /* Убираем синее выделение при тапе на мобилках */
    * {
      -webkit-tap-highlight-color: transparent;
    }
    
    /* Chrome, Edge, Safari */
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }

    ::-webkit-scrollbar-track {
      background: transparent;
      margin: 2px;
    }

    ::-webkit-scrollbar-thumb {
      background: linear-gradient(180deg, #6366f1 0%, #8b5cf6 100%);
      border-radius: 999px;
      border: none;
    }
    
    ::-webkit-scrollbar-thumb:hover {
      background: linear-gradient(180deg, #7c7fff 0%, #a78bfa 100%);
    }
    
    ::-webkit-scrollbar-thumb:active {
      background: #a78bfa;
    }
    
    /* Для body и html тоже применим */
    html, body {
      scrollbar-width: thin;
      scrollbar-color: ${theme === "dark" ? "#6366f1" : "#6366f1"} ${theme === "dark" ? "rgba(30, 41, 59, 0.5)" : "rgba(241, 245, 249, 0.8)"};
    }
  `;
  
  return (
    <div
      style={{
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        color: themeVars.fg,
        fontFamily: "Inter, Arial, sans-serif",
        display: "flex",
        flexDirection: "column",
        minHeight: "100dvh",
      }}
    >
      <style>{globalScrollStyles}</style>
      <style>{globalThemeTransitionStyles}</style>
      <style>{fastThemeTransitionStyles}</style>
      
{/* Фиксированный хедер — НЕ показываем в админ панели */}
{!isNewsPage && (
  <header
    style={{
      position: "fixed",
      top: headerInsetPx,
      left: headerInsetPx,
      right: headerInsetPx,
      zIndex: 1000,
    }}
  >
    {isMobile ? (
      <MobileSiteHeader
        theme={effectiveTheme}
        lang={lang}
        allowFrench={!isGuruDomain}
        isGuruDomain={isGuruDomain}
        token={token}
        onToggleTheme={handleToggleTheme}
        onToggleLang={handleToggleLang}
        pendingMatchesCount={pendingMatchesCount}
        isSamsungBrowser={isSamsungBrowser}
        onOpenAuthModal={!token ? () => eventAuthModalRef.current?.() : undefined}
      />
    ) : (
      <SiteHeader
        theme={effectiveTheme}
        lang={lang}
        allowFrench={!isGuruDomain}
        isGuruDomain={isGuruDomain}
        token={token}
        onToggleTheme={handleToggleTheme}
        onToggleLang={handleToggleLang}
        pendingMatchesCount={pendingMatchesCount}
        onOpenAuthModal={!token ? () => eventAuthModalRef.current?.() : undefined}
      />
    )}
  </header>
)}

      {/* Основной контент */}
      <main
        ref={mainScrollRef}
        data-app-scroll-root="true"
        style={{
          flex: 1,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          WebkitOverflowScrolling: "touch",
          paddingTop: isNewsPage
            ? "0px"
            : isEventAdminPage
            ? isMobile
              ? mobileMainPaddingTop
              : desktopMainPaddingTop
            : location.pathname === "/auth" || location.pathname === "/register"
            ? "0px"
            : isMobile
            ? mobileMainPaddingTop
            : desktopMainPaddingTop,
        }}
      >
        <div style={{ flex: 1 }}>
          <Routes>
            <Route
              path="/events/:slug"
              element={
                <EventDetailPage
                  lang={lang}
                  theme={theme}
                  translations={translations}
                  token={token}
                  onLogin={handleLogin}
                  isGuruDomain={isGuruDomain}
                  onRegisterAuthModal={(fn) => { eventAuthModalRef.current = fn; }}
                />
              }
            />
            
            <Route
              path="/auth"
              element={
                <LoginPage
                  lang={lang}
                  theme={theme}
                  translations={translations}
                  onLogin={handleLogin}
                  isSamsungBrowser={isSamsungBrowser}
                />
              }
            />
            
            <Route
              path="/register"
              element={
                <RegisterPage
                  lang={lang}
                  theme={theme}
                  translations={translations}
                  onLogin={handleLogin}
                  isSamsungBrowser={isSamsungBrowser}
                />
              }
            />
            
            {/* 🔥 Все остальные роуты - защищенные */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <LandingPage
                    lang={lang}
                    theme={effectiveTheme}
                    translations={translations}
                    token={token}
                    onToggleTheme={handleToggleTheme}
                    onToggleLang={handleToggleLang}
                    isGuruDomain={isGuruDomain}
                    isSamsungBrowser={isSamsungBrowser}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/how-it-works"
              element={
                <ProtectedRoute>
                  <HowItWorks lang={lang} theme={effectiveTheme} isSamsungBrowser={isSamsungBrowser} />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/privacy-policy"
              element={
                <ProtectedRoute>
                  <PrivacyPolicy lang={lang} theme={effectiveTheme} isSamsungBrowser={isSamsungBrowser} />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/cv-generator"
              element={
                <ProtectedRoute>
                  <CVGeneratorPage
                    lang={lang}
                    theme={theme}
                    translations={translations}
                  />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/events"
              element={
                <ProtectedRoute>
                  <EventsPage lang={lang} theme={theme} translations={translations} token={token} isGuruDomain={isGuruDomain} />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/events/create"
              element={
                <ProtectedRoute>
                  <EventCreatePage
                    lang={lang}
                    theme={theme}
                    translations={translations}
                    token={token}
                    isGuruDomain={isGuruDomain}
                  />
                </ProtectedRoute>
              }
            />
            {/* Панель модератора — динамический маршрут, видим только администраторам */}
            {adminRoute && (
              <>
                <Route
                  path={`/${adminRoute}/login`}
                  element={<ModeratorLoginPage adminRoute={adminRoute} />}
                />
                <Route
                  path={`/${adminRoute}`}
                  element={
                    <ProtectedModRoute adminRoute={adminRoute}>
                      <Navigate to={`/${adminRoute}/stats`} replace />
                    </ProtectedModRoute>
                  }
                />
                <Route
                  path={`/${adminRoute}/:tab`}
                  element={
                    <ProtectedModRoute adminRoute={adminRoute}>
                      <ModeratorPanel adminRoute={adminRoute} />
                    </ProtectedModRoute>
                  }
                />
              </>
            )}
            <Route
              path="/events/:eventId/edit"
              element={
                <ProtectedRoute>
                  <EventEditRequestPage
                    lang={lang}
                    theme={theme}
                    token={token}
                  />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/events/:slug/admin"
              element={
                <ProtectedRoute>
                  <EventAdminDashboard 
                    lang={lang} 
                    theme={theme}
                    onToggleTheme={handleToggleTheme}
                    onToggleLang={handleToggleLang}
                  />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/verify-email"
              element={
                <ProtectedRoute>
                  <VerifyEmailPage lang={lang} theme={theme} />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/invite-error"
              element={
                <ProtectedRoute>
                  <InviteErrorPage
                    lang={lang}
                    theme={theme}
                    translations={translations}
                  />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/chat"
              element={
                <ProtectedRoute>
                  <ChatPage 
                    lang={lang} 
                    theme={theme} 
                    translations={translations} 
                    token={token}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/chat/:chatId"
              element={
                <ProtectedRoute>
                  <ChatPage 
                    lang={lang} 
                    theme={theme} 
                    translations={translations} 
                    token={token}
                  />
                </ProtectedRoute>
              }
            />
            
            <Route path="/invitations" element={<Navigate to="/profile?section=invites" replace />} />
            <Route path="/matches" element={<Navigate to="/profile?section=matches" replace />} />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <InvitePage
                    lang={lang}
                    theme={effectiveTheme}
                    token={token}
                    translations={translations}
                    onLogout={handleLogout}
                    adminRoute={adminRoute}
                    isSamsungBrowser={isSamsungBrowser}
                  />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/system-status"
              element={
                <ProtectedRoute>
                  <SystemStatusPage theme={theme} lang={lang} />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="*"
              element={
                <ProtectedRoute>
                  <Navigate to={token ? "/profile" : "/auth"} replace />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </main>
      
      {/* Футер показываем только если НЕ на странице чата и НЕ в админ панели */}
      {showFooter && <Footer lang={lang} theme={theme} />}
      
      <ToastNotifications lang={lang} theme={theme} />
    </div>
  );
};

function App() {
  return (
    <Router>
      <RouteLogger />
      <AppContent />
    </Router>
  );
}

export default App;
